import http from '../utils/request'
// let baseUrl = "activity/api/precreate";
let baseUrl = "/api/barrage";
let api = "/config";
let ourGameApi = {
    /**
     * 获取服务器list
     * @param {Object} data
     */
    getServer(data) {
        return http({
            method: 'get',
            url: api+'/serverlist.json',
            params: data
        })
    },
    getServerStat(data){
        return http({
            method: 'get',
            url: baseUrl+'/getserverstat',
            params: data
        })
    },
    /**
     * 获取弹幕list
     * @param {Object} data
     */
    getBarrage (data) {
        return http({
            method: 'get',
            url: baseUrl+'/getbarragelist',
            params: data
        })
    },
    /**
     * 获取奖品list
     * @param {Object} data
     */
    getRecord (data) {
        return http({
            method: 'get',
            url: baseUrl+'/getawardlog',
            params: data
        })
    },
    /**
     * 获取角色list
     * @param {Object} data
     */
    getRoleList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetRoleList',
            params: data
        })
    },
    /**
     * 登录
     * @param {Object} data
     */
    login (data) {
        return http({
            method: 'get',
            url: baseUrl+'/login',
            params: data
        })
    },
    /**
     * 发送弹幕
     * @param {Object} data
     */
    sendBarrage (data) {
        return http({
            method: 'get',
            url: baseUrl+'/SendBarrage',
            params: data
        })
    },
    /**
     * 登录状态
     * @param {Object} data
     */
    isLogined (data) {
        return http({
            method: 'get',
            url: baseUrl+'/IsLogined',
            params: data
        })
    },
    /**
     * 退出登录
     * @param {Object} data
     */
    loginOut (data) {
        return http({
            method: 'get',
            url: baseUrl+'/loginOut',
            params: data
        })
    },
}
export default ourGameApi;


// WEBPACK FOOTER //
// ./src/api/api.js